import React, { useState, useEffect } from "react";
import Modal from "components/modal";

const ParcoursFormModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  initialParcours, 
  isEditing,
  existingParcours = [],
  loading 
}) => {
  const [parcours, setParcours] = useState({
    name_parcours: "",
    status_parcours: true
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen && initialParcours) {
      setParcours({
        name_parcours: initialParcours.name_parcours || "",
        status_parcours: initialParcours.status_parcours !== undefined ? initialParcours.status_parcours : true,
      });
      setValidationErrors({});
    }
  }, [isOpen, initialParcours]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setParcours({
      ...parcours,
      [name]: type === "checkbox" ? checked : value,
    });

    if (validationErrors[name]) {
      setValidationErrors({
        ...validationErrors,
        [name]: null,
      });
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!parcours.name_parcours.trim()) {
      errors.name_parcours = "Le nom du parcours est requis";
    } else if (
      !isEditing &&
      existingParcours.some(p => 
        p.name_parcours.toLowerCase() === parcours.name_parcours.toLowerCase()
      )
    ) {
      errors.name_parcours = "Ce nom de parcours existe déjà";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setSubmitting(true);
    
    const result = await onSubmit({
      name_parcours: parcours.name_parcours,
      status_parcours: parcours.status_parcours,
    });
    
    if (!result.success) {
      setValidationErrors(result.errors || {});
    }
    
    setSubmitting(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="md">
      <div className="text-center sm:text-left">
        <div className="mb-6">
          <h3 className="text-xl font-semibold text-gray-800">
            {isEditing
              ? "Modifier le parcours"
              : "Créer un nouveau parcours"}
          </h3>
          <div className="h-1 w-12 bg-[#57A863] mt-2 rounded-full"></div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="name_parcours"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Nom du parcours
            </label>
            <input
              type="text"
              name="name_parcours"
              id="name_parcours"
              value={parcours.name_parcours}
              onChange={handleInputChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
              placeholder="Ex: Informatique, Économie, Droit..."
            />
            {validationErrors.name_parcours && (
              <p className="mt-1.5 text-sm text-red-600">
                {validationErrors.name_parcours}
              </p>
            )}
          </div>

          <div className="flex items-start">
            <div className="flex items-center h-5">
              <input
                id="status_parcours"
                name="status_parcours"
                type="checkbox"
                checked={parcours.status_parcours}
                onChange={handleInputChange}
                className="h-4 w-4 rounded border-gray-300 text-[#57A863] focus:ring-[#57A863]"
              />
            </div>
            <div className="ml-3 text-sm">
              <label htmlFor="status_parcours" className="font-medium text-gray-700">
                Parcours actif
              </label>
              <p className="text-gray-500">
                Un parcours inactif ne sera pas disponible pour les nouvelles inscriptions.
              </p>
            </div>
          </div>

          {validationErrors.general && (
            <div className="rounded-md bg-red-50 p-3 border border-red-200">
              <p className="text-sm text-red-600">
                {validationErrors.general}
              </p>
            </div>
          )}

          <div className="mt-8 flex justify-end gap-3">
            <button
              type="button"
              className="px-4 py-2 rounded-md text-gray-600 border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
              onClick={onClose}
              disabled={submitting || loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-md bg-[#57A863] text-white hover:bg-[#4c9657] transition-colors shadow-sm"
              disabled={submitting || loading}
            >
              {(submitting || loading) ? (
                <span className="flex items-center">
                  <svg
                    className="-ml-1 mr-2 h-4 w-4 animate-spin text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Chargement...
                </span>
              ) : isEditing ? (
                "Mettre à jour"
              ) : (
                "Créer"
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ParcoursFormModal;